/**
 * The words the interactive charts write around the numbers, in English or, on
 * a chart's Spanish page (`chart.locale` "es", see Chart::Spanish), in Spanish.
 */

const WORDS = {
  en: {
    noData: 'No data to chart yet.',
    find: (thing) => `Find ${thing ? `a ${thing.toLowerCase()}` : 'a label'}`,
    placeholder: 'Type a name, e.g. Cook or Texas',
    showing: (shown, total) => `Showing ${shown} of ${total}`,
    nothing: (query) => `Nothing matches “${query}”.`,
    chart: 'Chart',
    legend: 'Legend',
    thisSeries: 'This series',
    noFigure: 'No figure',
    dashedLine: 'Dashed line:',
    trendYearly: (first, last, up, decade, all) =>
      `the straight-line trend, ${first}–${last}: ${up ? 'up' : 'down'} ${decade} a decade, ${all} in all.`,
    trend: (up, all) => `the straight-line trend: ${up ? 'up' : 'down'} ${all} from first to last.`,
    axisStart: (start) =>
      `The axis starts at ${start}, not zero, so small changes look larger: read the numbers on the axis, not only the line’s height.`,
    ranking: 'Ranking',
    showAs: 'Show as',
    bars: 'Ranked bars',
    map: 'Map',
    loadingMap: 'Loading the map…',
    matching: (shown, total) => `${shown} of ${total} match`,
    inAll: (total) => `${total} in all, highest first`,
    rankAnd: (thing) => `Rank and ${thing || 'label'}`,
    value: 'Value',
    showAll: (total, more) => `Show all ${total} (${more} more)`,
    showEnds: (count) => `Show only the top and bottom ${count}`,
    mapOf: (title) => `Map: ${title || 'states'}`,
    rankOf: (rank, total) => `rank ${rank} of ${total}`,
    noDataFor: 'no data',
    noDataKey: 'No data',
    rangeTo: (low, high) => `${low} to ${high}`,
    belowZero: 'States below zero have their own color; darker is further from zero. ',
    darker: (fifths) => `Darker is higher. Each shade holds about ${fifths ? 'a fifth' : 'an equal share'} of the states. `,
    dcNote: 'D.C. is too small to see on the map; find it in the ranked bars.',
    missing: (names) => ` No data for ${names}.`,
  },
  es: {
    noData: 'Todavía no hay datos.',
    find: () => 'Buscar',
    placeholder: 'Escribe un nombre, p. ej. Texas',
    showing: (shown, total) => `Se muestran ${shown} de ${total}`,
    nothing: (query) => `Nada coincide con “${query}”.`,
    chart: 'Gráfico',
    legend: 'Leyenda',
    thisSeries: 'Esta serie',
    noFigure: 'Sin cifra',
    dashedLine: 'Línea punteada:',
    trendYearly: (first, last, up, decade, all) =>
      `la tendencia en línea recta, ${first}–${last}: ${up ? 'sube' : 'baja'} ${decade} por década, ${all} en total.`,
    trend: (up, all) => `la tendencia en línea recta: ${up ? 'sube' : 'baja'} ${all} del primero al último.`,
    axisStart: (start) =>
      `El eje empieza en ${start}, no en cero, así que los cambios pequeños se ven más grandes: lee los números del eje, no solo la altura de la línea.`,
    ranking: 'Clasificación',
    showAs: 'Mostrar como',
    bars: 'Barras ordenadas',
    map: 'Mapa',
    loadingMap: 'Cargando el mapa…',
    matching: (shown, total) => `${shown} de ${total} coinciden`,
    inAll: (total) => `${total} en total, de mayor a menor`,
    rankAnd: (thing) => `Puesto y ${thing || 'nombre'}`,
    value: 'Valor',
    showAll: (total, more) => `Mostrar los ${total} (${more} más)`,
    showEnds: (count) => `Mostrar solo los ${count} primeros y los ${count} últimos`,
    mapOf: (title) => `Mapa: ${title || 'estados'}`,
    rankOf: (rank, total) => `puesto ${rank} de ${total}`,
    noDataFor: 'sin datos',
    noDataKey: 'Sin datos',
    rangeTo: (low, high) => `${low} a ${high}`,
    belowZero: 'Los estados bajo cero tienen su propio color; más oscuro es más lejos de cero. ',
    darker: (fifths) => `Más oscuro es más alto. Cada tono reúne más o menos ${fifths ? 'una quinta parte' : 'la misma cantidad'} de los estados. `,
    dcNote: 'D.C. es demasiado pequeño para verse en el mapa; búscalo en las barras ordenadas.',
    missing: (names) => ` Sin datos de ${names}.`,
  },
}

export function wordsFor(chart) {
  return WORDS[chart?.locale] ?? WORDS.en
}
